import reducers from './reducers';

const audienceReducers = {
  ageData: reducers.ageDataReducer,
  countryCityData: reducers.countryCityDataReducer,
  genderData: reducers.genderDataReducer,
};

export { audienceReducers };
